import { useTranslation } from 'react-i18next'

import useProductsSimilarModal from '@widgets/products-similar/hooks/useProductsSimilarModal'

import Button from '@shared/ui/button'


interface SimilarProductsTriggerProps {
  productId: string;
  className?: string;
  onClick?: () => void;
}

export default function SimilarProductsTrigger (
  props: SimilarProductsTriggerProps,
) {
  const { t: tc } = useTranslation('cart')
  const { productId, className, onClick } = props
  const { openProductsSimilarModal } = useProductsSimilarModal()

  const handleClick = () => {
    openProductsSimilarModal(productId)

    if (onClick) {
      onClick()
    }
  }

  return (
    <Button className={className} theme="secondary" onClick={handleClick}>
      {tc('replace_with_similar')}
    </Button>
  )
}
